import React, { useState } from 'react';
import { Button } from '@hud/web-components/Button/Button';
import { themeColor } from '@hud/web-components/theme/colors';
import styled, { css } from 'styled-components';

const OptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const StyledButton = styled(Button)<{ $isSelected: boolean }>`
  font-size: 13px;
  padding: 8px 16px;
  ${({ $isSelected }) => $isSelected && css`
    border-color: ${themeColor('turquoise')};
  `}
`;

export interface SingleSelectOptionsListProps {
  options: (string)[];
  initialSelectedIndex?: number;
  onChange?: (option: string) => void;
}

export const SingleSelectOptionsList: React.FC<SingleSelectOptionsListProps> = ({
  options,
  initialSelectedIndex = -1,
  onChange
}) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(initialSelectedIndex);

  const handleSelect = (index: number, option: string) => {
    setSelectedIndex(index);
    if (onChange) {
      onChange(option);
    }
  };

  return (
    <OptionsContainer>
      {options.map((option, index) => (
        <StyledButton
          key={index}
          variant="outlined"
          $isSelected={selectedIndex === index}
          onClick={() => handleSelect(index, option)}
        >
          {option}
        </StyledButton>
      ))}
    </OptionsContainer>
  );
};

export default SingleSelectOptionsList;
